import React, { useContext, useEffect, useState } from 'react';
import { AppActions } from 'store';
import { StateContext, DispatchContext } from 'context';
import './selector-thema.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTint, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import { withRouter } from "react-router-dom";
import { Themes } from 'styles';
import { IconButton } from '@mui/material';
const SelectorTema = (props) => {
    const state = useContext(StateContext);
    const dispatch = useContext(DispatchContext);
    const [modalSelector, setModalSelector] = useState(false);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 5;
    useEffect(() => {
    }, [])

    return (
        <>
            <button className="w3-btn grow"
                onClick={() => setModalSelector(true)}
                style={{ backgroundColor: Themes[indexTema].TH, position: 'fixed', top: 5, right: 5, zIndex: 20000000, borderRadius: '40px', padding: '5px 10px' }}><FontAwesomeIcon size="2x" icon={faTint} color="#fff"></FontAwesomeIcon></button>
            {(modalSelector) ? <div className="w3-modal w3-show">
                <div className="w3-modal-content w3-animate-zoom w3-round-large">
                    <div className="w3-row">
                        <div className="w3-col w3-right" style={{ width: '50px' }}>
                            <IconButton aria-label="delete" onClick={() => setModalSelector(false)}>
                                &nbsp;<FontAwesomeIcon icon={faTimes} color={'#3A3A3A'} />&nbsp;
                            </IconButton>
                        </div>
                        <div className="w3-rest w3-center">
                            <h4>Selector de tema</h4>
                        </div>
                    </div>
                    <div className="w3-padding paletas">
                        { Themes.map((theme, index) => <button className={"w3-block" + (indexTema === index ? " borde-verde" : "")} key={theme.TH} onClick={() => {
                            dispatch(AppActions.setIndexTema(index)); setModalSelector(false);
                            }}>
                            <div className="w3-row">
                                <div className="w3-col l1 m1 s1 w3-center w3-small w3-white"><span>Tema {index + 1} {indexTema === index ? <FontAwesomeIcon icon={faCheck} color={'#00cc00'} /> : null}</span></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.L5}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.L4}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.L3}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.L2}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.L1}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.TH}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.D1}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.D2}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.D3}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.D4}}></div>
                                <div className="w3-col l1 m1 s1" style={{backgroundColor: theme.D5}}></div>
                            </div>
                        </button>)}
                    </div>
                </div>
            </div> : null}
        </>
    );
}
export default withRouter(SelectorTema);